import styled from "styled-components";

export const Description = styled.p`
    font-weight: 400;
    color: var(--light-gray-5);
    font-size: 12px;
    line-height: 14px;
    margin: 0;
    width: 100%;
`;
